import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormControl,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";

// location: frontend/qiankun/upstyledpkgs/tui.image-editor-3.15.3
// must yarn remove tui-image-editor @toast-ui/react-image-editor
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ImageEditor from "@toast-ui/react-image-editor";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import TabPanel from "components/UpStyled/TabPanel";
import Compressor from "compressorjs";
import { AccountContext } from "context/account";
import { saveAs } from "file-saver";
import { nanoid } from "nanoid";
import NewSharedBar from "pages/de/share-page/newsharebar";
import AILabPageTurorialModal from "pages/tutorial/AILabPageTurorialModal";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import "react-image-crop/dist/ReactCrop.css";
import { Group, Image as KonvaImage, Layer, Line, Shape, Stage } from "react-konva";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";
import "tui-image-editor/dist/tui-image-editor.css";
import useImage from "use-image";
import {
  dataURLtoFile,
  getImageDimensions,
  resizeImg,
  getBase64ImageFromUrl,
} from "utils/imageHelper";

import colors from "assets/theme/base/colors";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import qs from "query-string";

import InputBase from "@mui/material/InputBase";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";

import { useDropzone } from "react-dropzone";
import UploadDropZone from "pages/fashionlab/components/UploadDropZone";
import UploadDropZoneFabric from "pages/fashionlab/components/UploadDropZoneFabric";

import FavoriteView from "pages/fashionlab/components/FavoriteView";
import ResultView from "pages/fashionlab/components/ResultView";

import MenuIcon from "@mui/icons-material/Menu";
import DirectionsIcon from "@mui/icons-material/Directions";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import CachedRoundedIcon from "@mui/icons-material/CachedRounded";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import ClothIcon from "components/Icon/ClothIcon";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ListIcon from "@mui/icons-material/List";
import FolderIcon from "@mui/icons-material/Folder";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";

import SegmentImageCard from "pages/fashionlab/components/SegmentImageCard";
import StyledToggleButtonGroup from "pages/fashionlab/components/StyledToggleButtonGroup";
import { convertToRLE } from "pages/ai/algo";
import AdvancedSettingModal from "pages/fashionlab/components/AdvancedSettingModal";
import AddFashionTagModal from "pages/fashionlab/components/AddFashionTagModal";
import DesignToolsCard from "pages/fashionlab/components/DesignToolsCard";
import SegmentImagesBar from "pages/fashionlab/components/SegmentImagesBar";
import InspirePromptModal from "pages/fashionlab/components/InspirePromptModal";
import InspirePromptTagModal from "pages/fashionlab/components/InspirePromptTagModal";
import DesignFileList from "pages/fashionlab/components/DesignFileList";

import { socket } from "services/request";

import { MAX_SCREEN_WIDTH } from "utils/data";
import { detailAILabUrlPrefix, promptTags, modelMap } from "utils/data";
import { capitalCase } from "capital-case";

const exampleImages = [
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/uV8VI7Gr7M3y8vKT7aliw/example-11.png",
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/uV8VI7Gr7M3y8vKT7aliw/example-12.png",
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/qycHlw0_9gyHw-ieKtzs7/default-12.png",
    //prompt: `A black skirt with a black crop top and black ankle boots.`,
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/uV8VI7Gr7M3y8vKT7aliw/example-13.jpeg",
  },
];

const fabricExampleImages = [
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/00q_RaBH1Ge-8s5WUaHaO/sketch_1.png",
    fabric:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/00q_RaBH1Ge-8s5WUaHaO/fabric_1",
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/nUoKENuHUIFfb1VHI4ApP/858712751_0-sketch.png",
    fabric:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/nUoKENuHUIFfb1VHI4ApP/fabric-11.png",
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/GADTjb7LWcO0NSDOrWoPk/sketch_3",
    fabric:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/GADTjb7LWcO0NSDOrWoPk/fabric_3",
  },
  {
    url: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/nUoKENuHUIFfb1VHI4ApP/861139403_1.png",
    fabric:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/nUoKENuHUIFfb1VHI4ApP/fabric-12.png",
  },
];

const formatJobConfig = (jobconf) => {
  const maxJobConfig = {
    batch_size: 1,
    max_num_inference_steps: 20,
    conditioning_scale: 0.6,
    guidance_scale: 7,
  };
  for (let key in maxJobConfig) {
    if (jobconf.hasOwnProperty(key) && jobconf[key] > maxJobConfig[key]) {
      jobconf[key] = maxJobConfig[key];
    }
  }
  return jobconf;
};

const defaultConfig = {
  task_type: modelMap[0].value,
  prompt: "",
  negative_prompt: "",
  batch_size: 1,
  max_num_inference_steps: 20,
  conditioning_scale: 0.6,
  guidance_scale: 7,
  coarse: false,
  extract_sketch: false,
  prompt_array: [],
};

// const allOptions = [...genderOptions, ...skinToneOptions, ...backgroundOptions];

let allOptions = [];
promptTags.forEach((x) => allOptions.push(...x.children));

const backgroundTags = promptTags.find((x) => x.value == "background");

const maxImageSize = 1024;
const maxViewSize = 512;

const FashionLabPage = ({ edit = false }) => {
  const [labData, setLabData] = useState(null);

  const [editNameVisible, setEditNameVisible] = useState(false);
  const [inputWidth, setInputWidth] = useState(22);
  const [isDirty, setIsDirty] = useState(false);
  const [jobconf, setJobconf] = useState({ ...defaultConfig });
  const [resultData, setResultData] = useState([]);
  const [sketchData, setSketchData] = useState(null);
  const [extra, setExtra] = useState(null);
  const [viewType, setViewType] = useState("detail");
  const [uploading, setUploading] = useState(false);
  const [advancedSettingVisible, setAdvancedSettingVisible] = useState(false);
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const [cachedSketchData, setCachedSketchData] = useState(null);
  const [addFashionTagVisible, setAddFashionTagVisible] = useState(false);
  const [maskType, setMaskType] = useState("mask");
  const [inspireVisible, setInspireVisible] = useState(false);
  const [inspireTagVisible, setInspireTagVisible] = useState(false);

  const [previousViewType, setPreviousViewType] = useState([]);
  const [sketchWidth, setSketchWidth] = useState(maxImageSize);
  const [sketchHeight, setSketchHeight] = useState(maxImageSize);
  const [runningJob, setRunningJob] = useState("");
  /** Prevents double-submit (e.g. double-click Generate) → duplicate POST /admin/ai-job → duplicate Gemini calls */
  const runAIJobInFlightRef = useRef(false);
  const [queueSize, setQueueSize] = useState(0);
  const [tempSize, setTempSize] = useState([]);
  const [finishId, setFinishId] = useState("");

  const [tabValue, setTabValue] = useState("design");
  const [randomSeed, setRandomSeed] = useState();

  let imgWidth = sketchWidth;
  let imgHeight = sketchHeight;
  if (imgHeight > maxImageSize) {
    let ratioY = maxImageSize / imgHeight;
    imgHeight = maxImageSize;
    imgWidth = parseInt(Math.floor(imgWidth * ratioY));
  }

  if (imgWidth > maxImageSize) {
    let ratioX = maxImageSize / imgWidth;
    imgWidth = maxImageSize;
    imgHeight = parseInt(Math.floor(imgHeight * ratioX));
  }

  const pathnames = window.location.pathname.split("/");
  let ailab_id = null;
  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "fashion-lab") {
    ailab_id = pathnames[pathnames.length - 1];
  }

  //const { ailab_id } = useParams();

  const nameInputRef = useRef(null);
  const segmentsRef = useRef({});
  const segmentImageRef = useRef(null);
  const stageRef = useRef(null);
  const promptRef = useRef(null);
  const uploadFabricRef = useRef(null);
  const uploadSketchRef = useRef(null);

  const account = useContext(AccountContext);
  const navigate = useNavigate();
  const location = useLocation();

  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const defaultImg = urlObj?.query?.img;

  const [background] = useImage(sketchData?.imgurl, "anonymous", "origin");

  useEffect(() => {
    if (account.id) {
      socket.on("ai_task_queue:add", ({ q, id }) => {
        //console.log(q);
        setTempSize(q);
        //console.log("trigger ai task update update");
      });

      socket.on("ai_task_queue:finish", ({ q, id }) => {
        //console.log(q);
        setTempSize(q);
        setFinishId(id);
        //console.log("trigger ai task update update");
      });
    }
  }, [account.id]);

  useEffect(() => {
    if (runningJob) {
      if (finishId == runningJob) {
        setQueueSize(0);
        return;
      }

      if (tempSize.length > 0 && tempSize[0] == runningJob) {
        setQueueSize(tempSize.length - 1);
      } else {
        setQueueSize(tempSize.length);
      }
    } else {
      setQueueSize(0);
    }
  }, [tempSize]);

  useEffect(() => {
    if (ailab_id) {
      loadAILab(ailab_id);
    } else {
      const initialData = {
        name: "Untitled",
      };
      setLabData(initialData);
      setViewType("detail");
      setSketchData(null);
      setResultData([]);
      setExtra(null);
      setJobconf({ ...defaultConfig });
    }
  }, [edit, ailab_id]);

  useEffect(() => {
    getPredefinedSketch(defaultImg);
  }, [defaultImg]);

  useEffect(() => {
    if (resultData.length == 0) {
      setViewType("detail");
    }
  }, [resultData]);

  const processImage = async (url, type = "image/*", name = "default", maxSize = maxImageSize) => {
    try {
      setUploading(true);
      let dim = { width: maxImageSize, height: maxImageSize };
      if (typeof url == "string") {
        dim = await getImageDimensions(url);
        const { width, height } = dim;
        const [imgWidth, imgHeight] = calImageDim(width, height, maxSize);
        let imageData = {
          name: name,
          type: type,
          width: imgWidth,
          height: imgHeight,
          imgurl: url,
        };

        if (width != imgWidth || height != imgHeight) {
          //we need to resize the image to make sure the largest side is smaller than maxImageSize
          const dataUri = await getBase64ImageFromUrl(url);
          const file = dataURLtoFile(dataUri, name);

          var blob = await resizeImg(file, imgWidth, imgHeight);
          var file2 = new File([blob], name, { type: file.type });
          const dir = ailab_id ? ailab_id + `/${nanoid()}` : `/fashionlab/new/${nanoid()}`;

          const imgurl = await api.uploads.create([file2], {}, dir).then(({ data }) => {
            const uploaded = data.uploads.map(({ url }) => url);
            return uploaded;
          });
          if (imgurl && imgurl.length == 1) {
            imageData["imgurl"] = imgurl[0];
            imageData["type"] = file.type;
          }
        }
        setUploading(false);
        return imageData;
      } else {
        //url is a file object
        var img;
        let file = url;
        img = new Image();
        var objectUrl = URL.createObjectURL(file);

        img.src = objectUrl;
        await img.decode();

        const width = img.width;
        const height = img.height;
        const [imgWidth, imgHeight] = calImageDim(width, height, maxSize);
        let imageData = {
          name: name,
          type: type,
          width: imgWidth,
          height: imgHeight,
          imgurl: objectUrl,
        };

        const dir = ailab_id ? ailab_id + `/${nanoid()}` : `/fashionlab/new/${nanoid()}`;
        if (width != imgWidth || height != imgHeight) {
          //we need to resize the image to make sure the largest side is smaller than maxImageSize
          var blob = await resizeImg(file, imgWidth, imgHeight);
          var file2 = new File([blob], name, { type: file.type });
          const imgurl = await api.uploads.create([file2], {}, dir).then(({ data }) => {
            const uploaded = data.uploads.map(({ url }) => url);
            return uploaded;
          });
          if (imgurl && imgurl.length == 1) {
            imageData["imgurl"] = imgurl[0];
            imageData["type"] = file.type;
          }
        } else {
          const imgurl = await api.uploads.create([file], {}, dir).then(({ data }) => {
            const uploaded = data.uploads.map(({ url }) => url);
            return uploaded;
          });
          if (imgurl && imgurl.length == 1) {
            imageData["imgurl"] = imgurl[0];
            imageData["type"] = file.type;
          }
        }

        URL.revokeObjectURL(objectUrl);
        setUploading(false);
        return imageData;
      }
    } catch (err) {
      console.log(err);
      setUploading(false);
      setUploading(false);
    }
  };

  const calImageDim = (width, height, maxSize = maxImageSize) => {
    let imgWidth = width;
    let imgHeight = height;

    if (height > maxSize) {
      let ratioY = maxSize / imgHeight;
      imgHeight = maxSize;
      imgWidth = parseInt(Math.floor(imgWidth * ratioY));
    }

    if (imgWidth > maxSize) {
      let ratioX = maxSize / imgWidth;
      imgWidth = maxSize;
      imgHeight = parseInt(Math.floor(imgHeight * ratioX));
    }
    return [imgWidth, imgHeight];
  };

  const getPredefinedSketch = async (url, model = "fabric") => {
    if (url) {
      const imgdata = await processImage(url);
      setSketchWidth(imgdata.width);
      setSketchHeight(imgdata.height);
      setSketchData(imgdata);
      setCachedSketchData(imgdata);
      setJobconf((prev) => ({
        ...prev,
        task_type: model,
        batch_size: 1,
      }));
    }
  };

  const getThumbnail = async (url) => {
    function blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }

    const response = await api.uploads.downloadurl({ url: url });
    var uri = "data:" + response.data.contenttype + ";base64," + response.data.base64;
    const file = dataURLtoFile(uri, nanoid());
    var blob = await resizeImg(file, sketchWidth / 4, sketchHeight / 4);
    var base64str = await blobToBase64(blob);
    //console.log('base64str', base64str.length)
    return base64str;
  };

  const loadAILab = async (id) => {
    try {
      const { data } = await api.ailab.get(id);
      setLabData(data.data);
      if (data.data.metadata) {
        if (data.data.metadata.sketchData) {
          const imgData = data.data.metadata.sketchData;
          setSketchHeight(imgData?.height || maxImageSize);
          setSketchWidth(imgData?.width || maxImageSize);
          setSketchData(imgData);
          setCachedSketchData(imgData);

          //if (data.data.metadata.sketchData.imgurl) setTabValue(1);
        }
        if (data.data.metadata.resultData) setResultData(data.data.metadata.resultData);
        if (data.data.metadata.jobconf) {
          let task_type = "gen.flat.sd";

          if (data.data.metadata.sketchData?.imgurl) {
            task_type = "gen.flat";
          } else if (data.data.metadata.sketchData?.fabric_imgurl) {
            task_type = "fabric";
          } else {
            task_type = "gen.flat.sd";
          }
          if (data.data.metadata.jobconf?.task_type) {
            task_type = data.data.metadata.jobconf?.task_type;
          }

          setJobconf({
            ...data.data.metadata.jobconf,
            task_type: task_type,
            batch_size: 1,
          });
        }
      }

      if (data.data?.extra) {
        setExtra(data.data.extra);
      }
    } catch (err) {
      toast.error(`Load ailab failed!`);
      console.log(err);
    }
  };

  const saveAILab = async () => {
    setIsDirty(false);
    let id = ailab_id;
    if (!id) {
      //do create
      const { data } = await api.ailab.save({ name: labData?.name || "Untitled" });
      window.history.replaceState("", "Fashion Lab", `${detailAILabUrlPrefix}/${data.id}`);
      id = data.id;
    }
    var payload = {
      id: id,
      img:
        sketchData?.imgurl && sketchData?.imgurl.length > 0
          ? { url: sketchData.imgurl, type: sketchData.type, name: "ailab" }
          : {},
      metadata: { sketchData: sketchData, resultData: resultData, jobconf: jobconf },
      extra: extra,
    };
    console.log(payload?.img);

    await api.ailab.save(payload);
  };

  useEffect(() => {
    if (isDirty) {
      saveAILab();
    }
  }, [isDirty]);

  const dropZoneOptions = { accept: { "image/*": [".jpeg", ".png", ".webm", ".jpg"] } };

  const handleChangeName = async () => {
    let value = nameInputRef?.current?.value || "";
    value = value.trim();
    if (value == labData.name || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      if (ailab_id) {
        //do update
        await api.ailab.save({ id: ailab_id, name: value });
        setLabData({ ...labData, name: value });
      } else {
        //do create
        const { data } = await api.ailab.save({ name: value });
        window.history.replaceState("", "Fashion Lab", `${detailAILabUrlPrefix}/${data.id}`);
        setLabData({ ...labData, name: value, id: data?.id });
      }

      toast.success("Update name successfully!");
    } catch (err) {
      console.log(err);
      toast.failed("Update name failed!");
    }
    setEditNameVisible(false);
  };

  const runAIJob = async (newjobconf) => {
    //POST to http://localhost:9008/admin/ai-job

    const promptStr = promptRef?.current?.value?.trim() || "";
    newjobconf = formatJobConfig(newjobconf);
    newjobconf.batch_size = 1;
    if (promptRef) {
      newjobconf.prompt = promptStr;
    }
    var task_type = newjobconf.task_type;

    const prompt_array = newjobconf?.prompt_array || [];
    const valid_prompt_array = prompt_array.filter((x) => x !== "");

    if (!sketchData?.imgurl) {
      task_type = "gen.flat.sd";
      newjobconf.task_type = "gen.flat.sd";
    }

    if (task_type != "gen.flat.sd") {
      //text-to-image model
      if (!sketchData?.imgurl) {
        //all models need a input image except text-to-image
        return toast.error("Please upload a image!");
      }
    } else {
      //text-to-image model
      if (newjobconf.prompt == "" && valid_prompt_array.length == 0) {
        return toast.error("Prompt can not be empty!");
      }
    }

    if (task_type == "fabric" && !sketchData?.fabric_imgurl) {
      //fabric model
      return toast.error("Please upload a fabric image!");
    }
    if (task_type == "gen.flat.inpaint") {
      //inpaint model

      if (newjobconf.prompt == "" && valid_prompt_array.length == 0) {
        //return toast.error("Prompt can not be empty!");
      }
    }

    setJobconf(newjobconf);

    if (!task_type || task_type === "") task_type = modelMap[0].value;

    var imgurl = sketchData?.imgurl || "";

    if (task_type === "fabric") imgurl = [imgurl, sketchData?.fabric_imgurl];

    var jobid = "new/" + task_type + "_" + nanoid();

    if (runAIJobInFlightRef.current) {
      return;
    }
    runAIJobInFlightRef.current = true;

    try {
      if (ailab_id) {
        jobid = ailab_id + "/" + task_type + "_" + nanoid();
      } else {
        //do create
        const { data } = await api.ailab.save({ name: labData?.name });
        setLabData({ ...labData, id: data?.id });
        jobid = data?.id + "/" + task_type + "_" + nanoid();
        window.history.replaceState("", "Fashion Lab", `${detailAILabUrlPrefix}/${data.id}`);
      }
      setRunningJob(jobid);

      var taskData = {
        task_type: task_type,
        id: jobid,
        owner_id: account.id,
        task_meta: {
          conditional: imgurl,
          task_type: task_type,
          prompt: newjobconf.prompt,
          negative_prompt: newjobconf.negative_prompt,
          batch_size: 1,
          max_num_inference_steps: newjobconf.max_num_inference_steps ?? 20,
          conditioning_scale: newjobconf.conditioning_scale,
          guidance_scale: newjobconf.guidance_scale,
          coarse: newjobconf.coarse,
          extract_sketch: newjobconf.extract_sketch,
          prompt_array: valid_prompt_array,
        },
      };

      if (sketchData?.imgurl && task_type == "gen.flat.inpaint") {
        //add inpaint area to task meta
        const segmentImage = segmentImageRef.current.segmentImage;
        if (!segmentImage) {
          setRunningJob(false);
          return toast.error("Please select the segment.");
        }
        var image = new Image();

        image.src = segmentImage;
        await image.decode();
        const canvas = document.createElement("canvas");
        const dw = sketchData.width;
        const dh = sketchData.height;
        let newMaskArea = Array(dw * dh).fill(0);
        canvas.width = dw;
        canvas.height = dh;

        let ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, dw, dh);
        const imageData = ctx.getImageData(0, 0, dw, dh);

        for (let j = 0; j < imageData.data.length; j += 4) {
          const pos = j / 4;
          let y = parseInt(Math.floor(pos / dw));
          let x = pos % dw;

          let index = x * dh + y;

          const r = imageData.data[j];
          const g = imageData.data[j + 1];
          const b = imageData.data[j + 2];
          const a = imageData.data[j + 3];
          if (r + g + b > 0) {
            newMaskArea[index] = 1;
          }
        }
        newMaskArea = [...newMaskArea].map((m) => (m > 0 ? 1 : 0));
        if (maskType === "nonmask") {
          newMaskArea = [...newMaskArea].map((m) => 1 - m);
          taskData["task_meta"]["task_type"] = "gen.flat.inpaint";
          taskData["task_type"] = "gen.flat.inpaint";
        } else {
          taskData["task_meta"]["task_type"] = "gen.flat.inpaint"; //"gen.flat.inpaint.xl"
          taskData["task_type"] = "gen.flat.inpaint"; //"gen.flat.inpaint.xl"
        }

        taskData["task_meta"]["mask_RLE"] = {
          counts: convertToRLE(newMaskArea),
          // [height, width] — must match canvas dw×dh used for newMaskArea (not stale sketchWidth state)
          size: [dh, dw],
        };
      }

      if (task_type == "gen.flat.sd") {
        //text-to-image can adjust output size
        let o_width = 912;
        let o_height = 1216;

        if (newjobconf?.aspect_ratio) {
          let ratio_str = newjobconf?.aspect_ratio.split("*");
          if (ratio_str.length == 2) {
            o_width = Number(ratio_str[0]);
            o_height = Number(ratio_str[1]);
          }
        }
        taskData["task_meta"]["width"] = o_width;
        taskData["task_meta"]["height"] = o_height;
      }

      await new Promise((resolve) => setTimeout(resolve, 100));
      const { data } = await api.ailab.sendJob(taskData);

      var images = data["results"];
      //console.log('taskData', taskData, 'data', data)
      var newImages = await Promise.all(
        images.map(async (url) => {
          return { url: url, thumbnail: await getThumbnail(url) };
        })
      );
      //console.log('newImages', newImages)
      setResultData([{ taskData: taskData, images: newImages, dt: new Date() }, ...resultData]);
      handleChangeViewType("list");

      let newCache = {};
      if (extra?.cache) {
        newCache = extra.cache;
      }
      newCache[newjobconf.task_type] = { newjobconf, sketchData };
      setExtra((prev) => ({ ...prev, cache: newCache }));

      setIsDirty(true);
      setRunningJob(false);
    } catch (err) {
      console.log(err);
      toast.error("Error to generate AI results!");
      setRunningJob(false);
    } finally {
      runAIJobInFlightRef.current = false;
    }
  };

  const handleClickExampleImage = async (item) => {
    try {
      const imgdata = await processImage(item.url);
      if (imgdata) {
        let conf = {
          prompt: item?.prompt || "",
          negative_prompt: item?.negative_prompt || "",
          prompt_array: [],
        };

        if (promptRef?.current) {
          promptRef.current.value = item?.prompt || "";
        }

        if (item?.fabric) {
          imgdata.fabric_imgurl = item.fabric;
          conf.task_type = "fabric";
        }
        setSketchData((prev) => ({ ...prev, ...imgdata }));
        setCachedSketchData((prev) => ({ ...prev, ...imgdata }));
        setSketchWidth(imgdata.width);
        setSketchHeight(imgdata.height);

        setJobconf((prev) => ({
          ...prev,
          ...conf,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleUploadImage = async (files) => {
    if (files.length > 0) {
      const file = files[0];

      try {
        setUploading(true);
        const imgdata = await processImage(file);
        setSketchData((prev) => ({ ...prev, ...imgdata }));
        setSketchWidth(imgdata.width);
        setSketchHeight(imgdata.height);
        if (!cachedSketchData?.imgurl) {
          setCachedSketchData((prev) => ({ ...prev, ...imgdata }));
        }
        console.log(jobconf);

        if (jobconf?.task_type == "gen.flat.sd" || !jobconf?.task_type) {
          console.log("trigger set gen.flat");
          setJobconf((prev) => ({ ...prev, task_type: "gen.flat" }));
        }

        setIsDirty(true);
        setViewType("detail");
        setUploading(false);
      } catch (err) {
        setUploading(false);

        console.log(err);
      }
    }
  };
  const handleUploadFabric = async (files) => {
    console.log("Upload fabric");
    if (files.length > 0) {
      const file = files[0];
      setUploading(true);
      try {
        var name = nanoid() + ".png";
        const imgdata = await processImage(file, "image/png", name, maxViewSize);

        setSketchData({ ...sketchData, fabric_imgurl: imgdata.imgurl });
        setCachedSketchData({ ...sketchData, fabric_imgurl: imgdata.imgurl });

        setIsDirty(true);
        setViewType("detail");
        setUploading(false);
      } catch (err) {
        console.log(err);
        setUploading(false);
      }
    }
  };

  const handleDeleteSegmentImage = (deleteSegmentUrl) => {
    let segment_imgs = extra?.segment_imgs || {};
    const imgurl = sketchData?.imgurl;

    if (imgurl && segment_imgs?.[imgurl] && deleteSegmentUrl) {
      let mySegmentImages = segment_imgs[imgurl] || [];
      mySegmentImages = mySegmentImages.filter((x) => x != deleteSegmentUrl);

      segment_imgs[imgurl] = mySegmentImages;
      setExtra((prev) => ({ ...prev, segment_imgs }));
      setIsDirty(true);
      toast.success(`Delete the segment image successfully!`);
    }
  };
  const BackButton = () => {
    let text = "";
    let type;
    if (viewType == "list") {
      text = "Back";
      type = "detail";
    } else if (viewType == "detail" && resultData?.length > 0) {
      text = "View results";
      type = "list";
    } else if (viewType == "favorite") {
      text = "Back";
      type = "detail";
    }

    return type ? (
      <SuiButton
        onClick={() => {
          setViewType(type);
        }}
        variant={type != "list" ? "text" : "contained"}
        size="small"
        color="dark"
        sx={{
          padding: "0px 8px",
          fontSize: type != "list" ? 14 : 12,
          lineHeight: 0,
          minHeight: 25,
          textTransform: "capitalize",
          borderRadius: "4px",
          mb: 0.5,
        }}
      >
        {type != "list" ? (
          <ArrowBackIcon sx={{ mr: 0.5, width: 16, height: 16 }} />
        ) : (
          <ListIcon sx={{ mr: 0.5, width: 16, height: 16 }} />
        )}{" "}
        {text}
      </SuiButton>
    ) : null;
  };

  const handleToggleFavorite = async (sketchData, findIndex) => {
    const favorite_list = extra?.favorite_list || [];
    try {
      if (findIndex == -1) {
        favorite_list.push({ ...sketchData });
      } else {
        favorite_list.splice(findIndex, 1);
      }

      setExtra((prev) => ({ ...prev, favorite_list }));
      setIsDirty(true);
      toast.success(`${findIndex == -1 ? "Save" : "Remove"} the result image successfully!`);
    } catch (err) {
      console.log(err);
      toast.error(`Failed to ${findIndex == -1 ? "save" : "remove"} the result image!`);
    }
  };

  const handleChangeViewType = (type) => {
    if (previousViewType.length > 0 && previousViewType[previousViewType.length - 1] != type) {
      setPreviousViewType((prev) => [...prev, type]);
    } else if (previousViewType.length == 0) {
      setPreviousViewType([type]);
    }

    setViewType(type);
  };

  const handleClickModel = (model, skipCache = false) => {
    const modelValue = model.value;

    if (modelValue != jobconf.task_type) {
      //only valid when user click a different model
      //cache previous model parameters
      let newCache = {};
      if (extra?.cache) {
        newCache = extra.cache;
      }

      let cached_key1 = jobconf.task_type;
      if (cached_key1 == "gen.flat" || cached_key1 == "gen.flat.inpaint") {
        cached_key1 = "gen.flat";
      }

      newCache[cached_key1] = { jobconf, sketchData };

      setExtra((prev) => ({ ...prev, cache: newCache }));

      //using cached setting for new model
      let cached_key2 = modelValue;
      if (modelValue == "gen.flat" || modelValue == "gen.flat.inpaint") {
        cached_key2 = "gen.flat";
      }
      const cachedData = extra?.cache?.[cached_key2] || {};
      let newJobConf = {
        ...jobconf,
        task_type: modelValue,
        batch_size: 1,
        //apply cached setting and data
        prompt_array: cachedData?.jobconf?.prompt_array ? cachedData?.jobconf.prompt_array : [],
        prompt: cachedData?.jobconf?.prompt ? cachedData?.jobconf.prompt : "",
        negative_prompt: cachedData?.jobconf?.negative_prompt
          ? cachedData?.jobconf.negative_prompt
          : "",
      };

      if (promptRef?.current) {
        //set input box value using ref
        promptRef.current.value = newJobConf?.prompt ? newJobConf.prompt : "";
      }
      //using cached data(image) for new model
      if (!skipCache) {
        if (modelValue == "gen.flat.inpaint" || modelValue == "gen.flat") {
          //using same sketchData for inpaint & image variation model
          let sharedCacheData = extra?.cache?.[cached_key2];
          if (!sharedCacheData) {
            sharedCacheData = {};
          }
          if (sharedCacheData?.["sketchData"]) {
            setSketchData(sharedCacheData?.["sketchData"]);
            setSketchWidth(sharedCacheData?.["sketchData"]?.width);
            setSketchHeight(sharedCacheData?.["sketchData"]?.height);
          } else {
            setSketchData(null);
            setSketchWidth(null);
            setSketchHeight(null);
          }
        } else if (modelValue == "gen.flat.sd") {
          //remove image in text-to-image model
          setSketchData(null);
        } else {
          setSketchData(cachedData?.["sketchData"]);
          setSketchWidth(cachedData?.["sketchData"]?.width);
          setSketchHeight(cachedData?.["sketchData"]?.height);
        }
      }
      setViewType("detail");
      setJobconf(newJobConf);
    }
  };

  const handleSetWorkingImage = async (x, fabric = "", mode = "image", task_meta) => {
    try {
      if (x) {
        setUploading(true);
        handleChangeViewType("detail");
        const imgdata = await processImage(x);
        const skipCache = true;

        if (task_meta?.prompt && promptRef?.current) {
          promptRef.current.value = task_meta?.prompt;
          setJobconf((prev) => ({ ...prev, prompt: task_meta?.prompt }));
        }
        if (task_meta?.prompt_array && task_meta?.prompt_array.length > 0) {
          setJobconf((prev) => ({ ...prev, prompt_array: task_meta.prompt_array }));
        }

        setSketchWidth(imgdata.width);
        setSketchHeight(imgdata.height);
        if (!fabric && mode != "fabric") {
          handleClickModel({ value: "gen.flat.inpaint" }, skipCache);
          setSketchData(imgdata);
        } else if (fabric) {
          handleClickModel({ value: "fabric" }, skipCache);
          setSketchData({ ...imgdata, fabric_imgurl: fabric });
        } else if (!fabric && mode == "fabric") {
          handleClickModel({ value: "fabric" }, skipCache);
          setSketchData({ ...imgdata });
        }

        setUploading(false);
      }
    } catch (err) {
      setUploading(false);

      console.log(err);
      toast.error("Error on resizing image!");
    }
  };

  const handleChangeDesignFile = async (item) => {
    try {
      window.history.replaceState("", "Fashion Lab", `${detailAILabUrlPrefix}/${item.id}`);
      console.log(item);
      setTabValue("folder");
      if (item?.metadata?.resultData && item?.metadata?.resultData.length > 0) {
        setViewType("list");
      }
      handleRefresh();
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefresh = async () => {
    setRandomSeed(Math.random());
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  return (
    <SuiBox key={randomSeed}>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          Waiting...
        </SuiTypography>
      </Backdrop>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={Boolean(runningJob)}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          {queueSize == 0 ? "Waiting..." : `There are ${queueSize} pending job...`}
        </SuiTypography>
      </Backdrop>
      <NewSharedBar
        type="ailab"
        data={labData}
        title={
          <SuiBox display="flex" justifyContent="center" alignItems="center">
            {editNameVisible ? (
              <div className="flex">
                <input
                  defaultValue={labData?.name}
                  ref={nameInputRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleChangeName();
                    }
                  }}
                  className="font-serif"
                  autoFocus
                  style={{
                    outline: "none",
                    border: "none",
                    width: inputWidth + "ch",
                    fontSize: "1.25rem",
                    lineHeight: 1.375,
                    fontWeight: 700,
                  }}
                  onChange={(e) => setInputWidth(e.target?.value?.length + 1)}
                  onBlur={handleChangeName}
                />
              </div>
            ) : (
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <Tooltip title={"Click to modify the name."}>
                  <SuiTypography
                    variant="h5"
                    className="font-serif"
                    fontWeight="bold"
                    textTransform="none"
                    onClick={() => {
                      setEditNameVisible(true);
                      setInputWidth(labData?.name?.length + 1);
                    }}
                  >
                    {labData?.name}
                  </SuiTypography>
                </Tooltip>
              </SuiBox>
            )}
          </SuiBox>
        }
        handleRefreshSourceData={loadAILab}
        extraAction={
          null
          // <PlayCircleIcon
          //   sx={{ cursor: "pointer", zIndex: 2 }}
          //   onClick={() => setTutorialVisible(true)}
          //   color="dark"
          //   fontSize="medium"
          // />
        }
      />

      <SuiBox display="flex">
        <SuiBox
          sx={{
            position: "sticky",
            top: 20,
            minWidth: { lg: 240, md: 240, sm: 170, xs: 170 },
            width: { lg: 240, md: 240, sm: 170, xs: 170 },
          }}
        >
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            aria-label="icon position tabs example"
            sx={{ mb: 0.5 }}
          >
            <Tab
              icon={<DesktopWindowsOutlinedIcon fontSize="small" />}
              iconPosition="start"
              label={
                <SuiTypography
                  sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                >
                  Tools
                </SuiTypography>
              }
              sx={{ fontSize: 14 }}
              {...a11yProps("design")}
            />
            <Tab
              icon={<FolderIcon fontSize="small" />}
              iconPosition="start"
              label={
                <SuiTypography
                  sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                >
                  Folder
                </SuiTypography>
              }
              sx={{ fontSize: 14 }}
              {...a11yProps("folder")}
            />
          </Tabs>
          <TabPanel value={tabValue} index={"design"}>
            <DesignToolsCard
              handleClickModel={handleClickModel}
              jobconf={jobconf}
              uploadFabricRef={uploadFabricRef}
              uploadSketchRef={uploadSketchRef}
              sketchData={sketchData}
              setJobconf={setJobconf}
              promptRef={promptRef}
              viewType={viewType}
              handleChangeViewType={handleChangeViewType}
            />
          </TabPanel>
          <TabPanel value={tabValue} index={"folder"}>
            <DesignFileList
              handleClick={handleChangeDesignFile}
              currentItemId={ailab_id}
              handleRefresh={handleRefresh}
            />
          </TabPanel>
        </SuiBox>

        <SuiBox sx={{ flex: "1 1 auto", mx: 2 }}>
          <SuiBox>
            <SuiBox sx={{ minHeight: "50vh" }}>
              <SuiBox display="flex" justifyContent="flex-start" alignItems="center" gap={2}>
                {BackButton()}

                {viewType != "favorite" ? (
                  <SuiButton
                    onClick={() => {
                      handleChangeViewType("favorite");
                    }}
                    variant="contained"
                    size="small"
                    color="dark"
                    sx={{
                      padding: "0px 8px",
                      fontSize: 12,
                      lineHeight: 0,
                      minHeight: 25,
                      minWidth: 130,
                      textTransform: "capitalize",
                      borderRadius: "4px",
                      mb: 0.5,
                    }}
                  >
                    <FavoriteRoundedIcon color="error" sx={{ mr: "2px", width: 14, height: 14 }} />
                    View my favorite
                  </SuiButton>
                ) : null}
              </SuiBox>

              <div style={{ display: viewType == "favorite" ? "block" : "none" }}>
                <FavoriteView
                  selectedResult={labData?.extra}
                  setViewType={handleChangeViewType}
                  handleSetWorkingImage={handleSetWorkingImage}
                  sketchData={sketchData}
                  handleToggleFavorite={handleToggleFavorite}
                  labData={labData}
                  extra={extra}
                />
              </div>

              <div style={{ display: viewType == "list" ? "block" : "none" }}>
                <ResultView
                  resultData={resultData}
                  setResultData={setResultData}
                  setIsDirty={setIsDirty}
                  setViewType={handleChangeViewType}
                  handleSetWorkingImage={handleSetWorkingImage}
                  sketchData={sketchData}
                  setJobconf={setJobconf}
                  handleToggleFavorite={handleToggleFavorite}
                  labData={labData}
                  extra={extra}
                />
              </div>
              <div
                style={{
                  display: viewType == "detail" ? "block" : "none",
                }}
              >
                <div style={{ display: jobconf.task_type != "gen.flat.sd" ? "block" : "none" }}>
                  {sketchData?.imgurl ? (
                    <SegmentImagesBar
                      imgurl={sketchData?.imgurl}
                      extra={extra}
                      handleDeleteSegmentImage={handleDeleteSegmentImage}
                      handleSetWorkingImage={handleSetWorkingImage}
                    />
                  ) : null}

                  <div
                    style={{
                      position: "relative",
                      display: viewType == "detail" ? "block" : "none",
                      textAlign: "center",
                      paddingRight:
                        sketchData?.fabric_imgurl &&
                        (jobconf.task_type == "fabric" || jobconf.task_type == "gen.flat.inpaint")
                          ? 100
                          : 0,
                    }}
                    className="hover-parent"
                  >
                    <div
                      style={{
                        position: "relative",
                        textAlign: "center",
                        margin: "auto",
                      }}
                    >
                      {sketchData?.imgurl ? (
                        <SegmentImageCard
                          ref={segmentImageRef}
                          stageRef={stageRef}
                          sketchWidth={imgWidth}
                          sketchHeight={imgHeight}
                          sketchData={sketchData}
                          account={account}
                          setSketchData={setSketchData}
                          setIsDirty={setIsDirty}
                          ailab_id={ailab_id}
                          segmentsRef={segmentsRef}
                          viewType={viewType}
                          setJobconf={setJobconf}
                          jobconf={jobconf}
                          uploadSketchRef={uploadSketchRef}
                          setExtra={setExtra}
                          extra={extra}
                          handleSetWorkingImage={handleSetWorkingImage}
                          runningJob={runningJob}
                          setRunningJob={setRunningJob}
                        />
                      ) : null}

                      <SuiBox
                        mx="auto"
                        style={{
                          maxWidth: 420,
                          minWidth: 200,
                          height: 400,
                          display: sketchData?.imgurl ? "none" : "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => {
                          if (uploadSketchRef?.current) {
                            uploadSketchRef.current?.open();
                          }
                        }}
                      >
                        <UploadDropZone
                          options={dropZoneOptions}
                          handleOnChange={handleUploadImage}
                          ref={uploadSketchRef}
                        />
                      </SuiBox>

                      {jobconf.task_type == "fabric" ? (
                        <div>
                          {sketchData?.fabric_imgurl ? (
                            <div
                              style={{
                                position: "absolute",
                                bottom: 0,
                                right: -80,
                              }}
                            >
                              <div style={{ position: "relative" }} className="hover-parent">
                                <SuiBox
                                  sx={{
                                    maxHeight: { xs: 80, sm: 80, md: 120, lg: 120 },
                                    width: { xs: 80, sm: 80, md: 120, lg: 120 },
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #000000",
                                  }}
                                >
                                  <img
                                    src={sketchData.fabric_imgurl}
                                    crossOrigin="Anonymous"
                                    width="100%"
                                    height="auto"
                                  />
                                </SuiBox>

                                <div className="hover-children">
                                  <IconButton
                                    size="small"
                                    color="dark"
                                    sx={{
                                      backgroundColor: "#ffffff",
                                      "&:hover": {
                                        backgroundColor: "#e3e3e3",
                                      },
                                      position: "absolute",
                                      right: 3,
                                      top: 3,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSketchData((prev) => ({
                                        ...prev,
                                        fabric_imgurl: null,
                                      }));
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 20,
                              display: sketchData?.fabric_imgurl ? "none" : "block",
                            }}
                          >
                            <SuiBox
                              mx="auto"
                              sx={{
                                maxWidth: 200,
                                height: { xs: 80, sm: 200, md: 200 },
                                mb: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => {
                                if (uploadFabricRef?.current) {
                                  uploadFabricRef.current?.open();
                                }
                              }}
                            >
                              <UploadDropZoneFabric
                                options={{ ...dropZoneOptions }}
                                handleOnChange={handleUploadFabric}
                                ref={uploadFabricRef}
                                icon={<ClothIcon fontSize="large" className="h-14 w-14" />}
                                message={
                                  <span>
                                    Drag and drop your <strong>fabric</strong> image here or click
                                    the space to upload
                                  </span>
                                }
                              />
                            </SuiBox>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display:
                      viewType == "detail" && jobconf.task_type == "gen.flat.sd" ? "block" : "none",
                  }}
                >
                  <Card sx={{ mt: 1 }}>
                    <SuiBox
                      mx="auto"
                      sx={{
                        maxWidth: 420,
                        height: 400,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: 2,
                      }}
                    >
                      <SuiTypography variant="h6">
                        Select the tags you’d like to see in your design or type the prompts below.
                      </SuiTypography>
                    </SuiBox>
                  </Card>
                </div>

                <div
                  style={{
                    display:
                      !sketchData?.imgurl &&
                      (jobconf.task_type == "gen.flat" ||
                        jobconf.task_type == "gen.flat.inpaint") &&
                      viewType == "detail"
                        ? "block"
                        : "none",
                  }}
                >
                  <div>
                    <Paper sx={{ textAlign: "center", my: 1, mx: 2 }}>
                      <SuiBox pt={1}>
                        <SuiTypography variant="body1" color="dark">
                          No image? Try one of these
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox
                        display="flex"
                        sx={{
                          flexWrap: "nowrap",
                          gap: 2,
                          py: 1,
                          px: 0.5,
                          overflow: "hidden",
                          justifyContent: "center",
                        }}
                      >
                        {exampleImages.map((item, index) => (
                          <div
                            style={{
                              width: 80,
                              minWidth: 80,
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <ImageCardWrapper
                              data={{ type: "image/*", url: item.url }}
                              alt="example img"
                              width={80}
                              height={120}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClickExampleImage(item)}
                            />
                            {item?.fabric ? (
                              <SuiBox sx={{ position: "absolute", bottom: 0, left: 0 }}>
                                <ImageCardWrapper
                                  data={{ type: "image/*", url: item.fabric }}
                                  alt="fabric img"
                                  width={25}
                                  height={25}
                                  style={{ cursor: "pointer" }}
                                />
                              </SuiBox>
                            ) : null}
                          </div>
                        ))}
                      </SuiBox>
                    </Paper>
                  </div>
                </div>
                <div
                  style={{
                    display:
                      !sketchData?.imgurl && jobconf.task_type == "fabric" && viewType == "detail"
                        ? "block"
                        : "none",
                  }}
                >
                  <div>
                    <Paper sx={{ textAlign: "center", my: 1, mx: 2 }}>
                      <SuiBox pt={1}>
                        <SuiTypography variant="body1" color="dark">
                          No image? Try one of these
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox
                        display="flex"
                        sx={{
                          flexWrap: "nowrap",
                          gap: 2,
                          py: 1,
                          px: 0.5,
                          overflow: "hidden",
                          justifyContent: "center",
                        }}
                      >
                        {fabricExampleImages.map((item, index) => (
                          <div
                            style={{
                              width: 80,
                              minWidth: 80,
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <ImageCardWrapper
                              data={{ type: "image/*", url: item.url }}
                              alt="example img"
                              width={80}
                              height={120}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClickExampleImage(item)}
                            />
                            {item?.fabric ? (
                              <SuiBox sx={{ position: "absolute", bottom: 0, right: 0 }}>
                                <ImageCardWrapper
                                  data={{ type: "image/*", url: item.fabric }}
                                  alt="fabric img"
                                  width={25}
                                  height={25}
                                  style={{ cursor: "pointer" }}
                                />
                              </SuiBox>
                            ) : null}
                          </div>
                        ))}
                      </SuiBox>
                    </Paper>
                  </div>
                </div>
              </div>
            </SuiBox>
            <SuiBox
              sx={{
                position: "relative",
                width: "100%",
                mx: 3,
              }}
            >
              <SuiBox
                px={2}
                mt={2}
                sx={{
                  width: "100%",
                }}
              >
                {sketchData?.imgurl && jobconf?.task_type == "gen.flat.inpaint" ? (
                  <Paper sx={{ mb: 0.5, px: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <SuiBox px={2} py={0.5}>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={maskType}
                          onChange={(e, v) => setMaskType(v)}
                        >
                          <FormControlLabel
                            value="mask"
                            control={<Radio />}
                            label="Refine chosen area"
                            disableTypography
                          />

                          <FormControlLabel
                            value="nonmask"
                            control={<Radio />}
                            label="Refine outside area"
                            disableTypography
                          />
                        </RadioGroup>
                      </SuiBox>
                      {/* {sketchData?.fabric_imgurl &&
                      sketchData?.imgurl &&
                      jobconf.task_type == "fabric" ? (
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={jobconf?.extract_sketch}
                              onChange={(e, value) =>
                                setJobconf((prev) => ({
                                  ...prev,
                                  extract_sketch: value,
                                }))
                              }
                            />
                          }
                          label="Extract Sketch"
                          disableTypography
                        />
                      ) : null} */}
                    </Stack>
                  </Paper>
                ) : null}
                <Paper
                  elevation={3}
                  sx={{
                    p: 1,

                    width: "100%",
                    borderRadius: "16px",
                    border: "1px solid #39475E",
                  }}
                >
                  <InputBase
                    sx={{ flex: 1, border: "none" }}
                    placeholder="Describe the image you want to generate"
                    inputProps={{ ref: promptRef }}
                    onKeyDown={(e) => {
                      if (e.code == "Enter") {
                        runAIJob({ ...jobconf });
                      }
                    }}
                    multiline
                    maxRows={4}
                    minRows={1}
                  />
                  <Stack
                    direction="row"
                    spacing={0.5}
                    alignItems="center"
                    sx={{ flexWrap: "wrap", mb: 1 }}
                  >
                    {sketchData?.fabric_imgurl &&
                    sketchData?.imgurl &&
                    jobconf.task_type == "fabric" ? (
                      <SuiBox>
                        <Chip
                          avatar={<Avatar alt="fabric_avatar" src={sketchData?.fabric_imgurl} />}
                          label={"Fabric"}
                          color="secondary"
                          sx={{ mb: 0.5 }}
                          onDelete={(e) => {
                            setSketchData((prev) => ({
                              ...prev,
                              fabric_imgurl: null,
                            }));
                          }}
                        />
                      </SuiBox>
                    ) : null}
                    {jobconf?.prompt_array && jobconf.prompt_array.length > 0
                      ? jobconf.prompt_array.map((pp, index) => {
                          if (pp == "") {
                            return null;
                          }

                          let foundIndex = allOptions.findIndex((x) => x.value == pp);
                          let label = pp;
                          if (foundIndex > -1) {
                            label = allOptions[foundIndex]?.label || allOptions[foundIndex]?.title;
                          }
                          return (
                            <SuiBox>
                              <Chip
                                avatar={
                                  allOptions[foundIndex]?.img ? (
                                    <Avatar alt="option_avatar" src={allOptions[foundIndex]?.img} />
                                  ) : null
                                }
                                label={capitalCase(label)}
                                variant="outlined"
                                sx={{ mb: 0.5 }}
                                onDelete={() => {
                                  const prompt_array = jobconf?.prompt_array || [];
                                  let newPrePrompt = [...prompt_array];
                                  //newPrePrompt[index] = "";
                                  newPrePrompt.splice(index, 1);

                                  setJobconf((prev) => ({
                                    ...prev,
                                    prompt_array: newPrePrompt,
                                  }));
                                }}
                              />
                            </SuiBox>
                          );
                        })
                      : null}

                    {jobconf?.prompt_array && jobconf.prompt_array.length > 0 ? (
                      <Chip
                        label="Clear Tags"
                        onClick={() => {
                          setJobconf((prev) => ({
                            ...prev,
                            prompt_array: [],
                          }));
                        }}
                      />
                    ) : null}
                  </Stack>
                  <SuiBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                    <Stack
                      direction="row"
                      spacing={0.5}
                      alignItems="center"
                      sx={{ flexWrap: "wrap" }}
                    >
                      <IconButton aria-label="menu" onClick={() => setAdvancedSettingVisible(true)}>
                        <MenuIcon />
                      </IconButton>
                      <SuiButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          px: 2,
                        }}
                        onClick={() => setAddFashionTagVisible(true)}
                      >
                        +Add Tags
                      </SuiButton>
                      {/* <SuiButton
                        variant="gradient"
                        color="secondary"
                        size="small"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "flex",
                            lg: "flex",
                            textTransform: "capitalize",
                          },
                          px: 2,
                        }}
                        onClick={() => {
                          if (
                            promptRef?.current?.value ||
                            (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                          ) {
                            setInspireVisible(true);
                          } else {
                            toast.error("Please input some keywords or select some tags! ");
                          }
                        }}
                      >
                        Inspire
                      </SuiButton> */}
                    </Stack>

                    <SuiBox display="flex" alignItems="center" gap={0.5}>
                      <IconButton
                        color="primary"
                        sx={{
                          display: {
                            xs: "inline-flex",
                            sm: "inline-flex",
                            md: "none",
                            lg: "none",
                            flex: "1 0 auto",
                          },
                        }}
                        aria-label="inspire"
                        onClick={() => {
                          if (
                            promptRef?.current?.value ||
                            (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                          ) {
                            setInspireVisible(true);
                          } else {
                            toast.error("Please input some keywords or select some tags! ");
                          }
                        }}
                      >
                        <TipsAndUpdatesIcon fontSize="medium" />
                      </IconButton>
                      <SuiButton
                        variant="gradient"
                        color="secondary"
                        size="small"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "flex",
                            lg: "flex",
                            textTransform: "capitalize",
                          },
                          px: 2,
                        }}
                        onClick={() => {
                          if (
                            promptRef?.current?.value ||
                            (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                          ) {
                            setInspireTagVisible(true);
                          } else {
                            toast.error("Please input some keywords or select some tags! ");
                          }
                        }}
                      >
                        AI Tags
                      </SuiButton>
                      <SuiButton
                        variant="gradient"
                        color="secondary"
                        size="small"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "flex",
                            lg: "flex",
                            textTransform: "capitalize",
                          },
                          px: 2,
                        }}
                        onClick={() => {
                          if (
                            promptRef?.current?.value ||
                            (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                          ) {
                            setInspireVisible(true);
                          } else {
                            toast.error("Please input some keywords or select some tags! ");
                          }
                        }}
                      >
                        AI Prompts
                      </SuiButton>

                      <SuiButton
                        variant="gradient"
                        color="info"
                        size="small"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "flex",
                            lg: "flex",
                            textTransform: "capitalize",
                          },
                          fontSize: 14,
                        }}
                        onClick={() => {
                          runAIJob({ ...jobconf });
                        }}
                      >
                        Generate
                      </SuiButton>
                      <IconButton
                        color="primary"
                        sx={{
                          display: {
                            xs: "inline-flex",
                            sm: "inline-flex",
                            md: "none",
                            lg: "none",
                            flex: "1 0 auto",
                          },
                        }}
                        aria-label="directions"
                        onClick={() => {
                          runAIJob({ ...jobconf });
                        }}
                      >
                        <DirectionsIcon fontSize="medium" />
                      </IconButton>
                    </SuiBox>
                  </SuiBox>
                </Paper>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {sketchData?.imgurl ? (
        <div style={{ position: "fixed", top: -10000, left: -10000 }}>
          <img src={sketchData.imgurl} id="backgroundImage" crossOrigin="Anonymous" />
          <Stage ref={stageRef} className="konva" width={sketchWidth} height={sketchHeight}>
            <Layer>
              <KonvaImage image={background} width={sketchWidth} height={sketchHeight} />
            </Layer>
          </Stage>
        </div>
      ) : null}

      {advancedSettingVisible ? (
        <AdvancedSettingModal
          visible={advancedSettingVisible}
          jobconf={jobconf}
          handleClose={() => setAdvancedSettingVisible(false)}
          setJobconf={setJobconf}
        />
      ) : null}
      {tutorialVisible ? (
        <AILabPageTurorialModal
          visible={tutorialVisible}
          handleClose={() => setTutorialVisible(false)}
        />
      ) : null}
      {addFashionTagVisible ? (
        <AddFashionTagModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setAddFashionTagVisible(false)}
          visible={addFashionTagVisible}
        />
      ) : null}
      {inspireVisible ? (
        <InspirePromptModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setInspireVisible(false)}
          visible={inspireVisible}
          promptRef={promptRef}
        />
      ) : null}
      {inspireTagVisible ? (
        <InspirePromptTagModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setInspireTagVisible(false)}
          visible={inspireTagVisible}
          promptRef={promptRef}
        />
      ) : null}
    </SuiBox>
  );
};

export default FashionLabPage;
